export class DtoCodigoNombreUnidad {
    Codigo: string = "";
    Nombre: string = "";
    UnidadMedida: string = "";
}